import axios from "axios";

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/admin/content`;

/* =========================
   TOKEN HELPER
========================= */
const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token")

  return token
    ? { Authorization: `Bearer ${token}` }
    : {};
};

/* =========================
   API CALLS
========================= */

export const getAdminContentBySection = async (page, section) => {
  const res = await axios.get(API_BASE, {
    params: { page, section },
    headers: {
      ...getAuthHeaders(),
    },
  });
  return res.data;
};

export const updateAdminContentText = async (id, payload) => {
  await axios.put(
    `${API_BASE}/${id}/text`,
    payload,
    {
      headers: {
        ...getAuthHeaders(),
      },
    }
  );
};

export const uploadAdminContentMedia = async (id, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await axios.post(
    `${API_BASE}/${id}/media`,
    formData,
    {
      headers: {
        ...getAuthHeaders(),
      },
    }
  );

  return res.data;
};

export const replaceAdminContentMedia = async (id, mediaId, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await axios.put(
    `${API_BASE}/${id}/media/${mediaId}`,
    formData,
    {
      headers: {
        ...getAuthHeaders(),
      },
    }
  );

  return res.data;
};

export const deleteAdminContentMedia = async (id, mediaId) => {
  const numericId = Number(id);
  const numericMediaId = Number(mediaId);
  await axios.delete(
    `${API_BASE}/${numericId}/media/${numericMediaId}`,
    {
      headers: {
        ...getAuthHeaders(),
      },
    }
  );
};

export const createAdminContentItem = async (payload) => {
  const res = await axios.post(
    API_BASE,
    payload,
    {
      headers: {
        ...getAuthHeaders(),
      },
    }
  );
  return res.data;
};

export const deleteAdminContentItem = async (id) => {
  await axios.delete(
    `${API_BASE}/${id}`,
    {
      headers: {
        ...getAuthHeaders(),
      },
    }
  );
};
